import React from "react";
import StateFlow from "../stateFlow";

interface StateFlowSkeletonProps {
  stepCount: number;
}

const StateFlowSkeleton: React.FC<StateFlowSkeletonProps> = (props) => {
  const { stepCount } = props;
  return (
    <StateFlow
      steps={[...Array(stepCount)].map((c, index) => ({
        state: index,
        stateText: "---",
      }))}
      currentState={undefined}
      loading
    />
  );
};

export default StateFlowSkeleton;
